import { render } from "./NothingArea.vue?vue&type=template&id=3e440792&bindings={\"label\":\"props\",\"items\":\"props\"}"
import script from "./NothingArea.vue?vue&type=script&lang=ts"
export * from "./NothingArea.vue?vue&type=script&lang=ts"

import "./NothingArea.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script